import React from 'react';
import { useLocation } from 'react-router-dom';

import { finleyAssert } from '@finley-technologies/common';
import { DataPipeline } from '@finley-technologies/finley-types';

import { InstanceGraphProvider } from '../../hooks/instanceGraphContext';
import { GraphHeader } from './GraphHeader';
import { GraphRenderer } from './GraphRenderer';
import { InstanceOptionalDrawer } from './InstanceDrawer';
import { Breadcrumbs } from '~/packages/common-frontend/components/Breadcrumbs';
import { SlugToNameProvider } from '~/packages/dataPipeline/hooks/slugToNameContext';
import { UploadContextProvider } from '~/packages/dataPipeline/hooks/UploadContext';
import { GraphFooter } from '~/packages/dataPipeline/ui/details/GraphFooter';

export const DataPipelineDetails = ({
  meshId: meshRunId,
  organizationId,
}: {
  meshId: string;
  organizationId: string;
}) => {
  const location = useLocation();
  const searchParams = location.search;

  finleyAssert(
    DataPipeline.isMeshId(meshRunId),
    `InValid meshId: ${meshRunId}`,
  );

  return (
    <SlugToNameProvider organizationId={organizationId}>
      <Breadcrumbs
        // we use relative paths here so that the same code works on both
        // admin and customer dashboard.
        // or is it better to move this into the router?
        breadcrumbs={[{ label: 'Data Pipeline', path: `../${searchParams}` }]}
      />

      <UploadContextProvider
        meshRunId={meshRunId}
        organizationId={organizationId}
        meshRunParams={null}
      >
        <InstanceGraphProvider>
          <GraphHeader organizationId={organizationId} />
          <GraphRenderer />
          <GraphFooter />
          <InstanceOptionalDrawer />
        </InstanceGraphProvider>
      </UploadContextProvider>
    </SlugToNameProvider>
  );
};
